import { Link } from "react-router-dom";

/** Edit / Delete / Extend — inline next to masked password. */
export default function SlaveAccountRowToolbar({
  row,
  editingId,
  actionLoadingId,
  connectLoadingId,
  deleteConfirmId,
  canExtend = false,
  extendTo,
  onEdit,
  onSave,
  onCancelEdit,
  onDeleteClick,
  onDeleteConfirm,
  onDeleteCancel,
}) {
  const busy =
    actionLoadingId === row.id ||
    connectLoadingId === row.id ||
    editingId === row.id;

  if (deleteConfirmId === row.id) {
    return (
      <span className="inline-flex shrink-0 items-center gap-1.5">
        <button
          type="button"
          disabled={busy}
          onClick={onDeleteConfirm}
          className="rounded-lg border border-red-300 bg-red-50 px-2.5 py-1 text-xs font-semibold text-red-700 transition hover:bg-red-100 disabled:opacity-60 dark:border-red-500/40 dark:bg-red-500/10 dark:text-red-300"
        >
          {actionLoadingId === row.id ? "Deleting…" : "Confirm"}
        </button>
        <button
          type="button"
          disabled={actionLoadingId === row.id}
          onClick={onDeleteCancel}
          className="rounded-lg border border-gray-300 px-2.5 py-1 text-xs font-semibold text-gray-700 transition hover:bg-gray-100 dark:border-white/15 dark:text-gray-200"
        >
          Cancel
        </button>
      </span>
    );
  }

  if (editingId === row.id) {
    return (
      <span className="inline-flex shrink-0 items-center gap-1.5">
        <button
          type="button"
          disabled={busy}
          onClick={onSave}
          className="rounded-lg border border-brand-400 bg-brand-500 px-2.5 py-1 text-xs font-semibold text-white transition hover:bg-brand-600 disabled:opacity-60"
        >
          {actionLoadingId === row.id ? "Saving…" : "Save"}
        </button>
        <button
          type="button"
          disabled={actionLoadingId === row.id}
          onClick={onCancelEdit}
          className="rounded-lg border border-gray-300 px-2.5 py-1 text-xs font-semibold text-gray-700 transition hover:bg-gray-100 dark:border-white/15 dark:text-gray-200"
        >
          Cancel
        </button>
      </span>
    );
  }

  return (
    <span className="inline-flex shrink-0 items-center gap-1.5">
      <button
        type="button"
        disabled={busy}
        onClick={onEdit}
        className="rounded-lg border border-gray-300 px-2.5 py-1 text-xs font-semibold text-gray-700 transition hover:bg-gray-100 disabled:opacity-60 dark:border-white/15 dark:text-gray-200 dark:hover:bg-white/10"
      >
        Edit
      </button>
      <button
        type="button"
        disabled={busy}
        onClick={onDeleteClick}
        className="rounded-lg border border-red-300 px-2.5 py-1 text-xs font-semibold text-red-700 transition hover:bg-red-50 disabled:opacity-60 dark:border-red-500/40 dark:text-red-300 dark:hover:bg-red-500/10"
      >
        Delete
      </button>
      {canExtend && extendTo ? (
        <Link
          to={extendTo}
          className="rounded-lg border border-violet-300 bg-violet-50 px-2.5 py-1 text-xs font-semibold text-violet-900 transition hover:bg-violet-100 dark:border-violet-500/40 dark:bg-violet-500/15 dark:text-violet-100 dark:hover:bg-violet-500/25"
        >
          Extend
        </Link>
      ) : null}
    </span>
  );
}
